import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryGrid from './components/CategoryGrid';
import WhyBuyersSection from './components/WhyBuyersSection';
import SafeBuyingSection from './components/SafeBuyingSection';
import CTABanner from './components/CTABanner';
import ArticleTeaserSection from './components/ArticleTeaserSection';
import FAQSection from './components/FAQSection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyspreadsheet.coupons';

export default function Home() {
  return (
    <>
      <Navbar />
      <main className="pb-20 md:pb-0">
        <Hero />
        <CategoryGrid />
        <WhyBuyersSection />
        <SafeBuyingSection />
        <CTABanner />
        <section id="guides">
          <ArticleTeaserSection />
        </section>
        <FAQSection />
      </main>
      <Footer />

      {/* Site-wide Schema.org JSON-LD */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: 'Kakobuy Spreadsheet',
            url: siteUrl,
            description: 'The largest kakobuy spreadsheet directory and buying guide with trusted sellers, product comparisons, and safety tips.',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Organization',
            name: 'Kakobuy Spreadsheet',
            url: siteUrl,
            description: 'The largest kakobuy spreadsheet directory and buying resource',
            foundingDate: '2026',
            logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png',
          }),
        }}
      />
    </>
  );
}